<template lang="pug">
.c-progress-form__element
  label.c-progress-form__title(v-html="$t(`profiles.questions.${name}`)")
  .c-multiple-choice
    .row.c-multiple-choice__options
      .column.c-multiple-choice__item.c-multiple-choice__item--number(v-for="(n, i) in parseInt(number)")
        input.c-multiple-choice__radio(type="radio" :name="name" :id="numberId(i)" :value="i" v-model="vehicles")
        label.c-multiple-choice__label(:for="numberId(i)") {{i}}
</template>

<script>
export default {
  props: {
    name: '',
    number: {
      default: 6
    }
  },
  computed: {
    vehicles: {
      get () {
        return this.$store.state.person[this.name] || 0
      },
      set (value) {
        this.$store.commit('updatePersonInfo', {name: this.name, value: value})
      }
    }
  },
  methods: {
    numberId (n) {
      return `${this.name}_${n}`
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/profiles/Vehicles.vue